import { usePermission } from "../../../../hooks/usePermission";

export const QUALITATIVE_CREATE = "qualitative-data.create";
export const QUALITATIVE_VIEW = "qualitative-data.view";

/**
 * Capability gates for the Qualitative page, read from the
 * `authorization/user/capabilities` response already loaded into
 * PermissionMenuContext (no extra fetch).
 *
 *   canCreate — qualitative-data.create (add/edit data, prefill, upload documents)
 *   canView   — qualitative-data.view   (history, view documents)
 */
export function useQualitativeCapabilities() {
  const [canCreate, canView] = usePermission([QUALITATIVE_CREATE, QUALITATIVE_VIEW]);
  return { canCreate, canView };
}
